import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';

import HelpText from '../../components/help/HelpText';
import { onlineDeviceColor, renderPhotoStatus } from '../../utilities/Generic';
import { request, handleRequestErrors } from '../../helpers/Requests'

class Devices extends Component {
  render() {
    const { devices, loaded, error, unauthorized } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      return (
        <div className="widget">
          <div className="table big-table">
            <div className="tr heading">
              <div className="th">Device name</div>
              <div className="th">Last updated</div>
              <div className="th">Last contacted</div>
              <div className="th">Online Devices<HelpText className="th-helptext" page={'device'} section={'online_device_count'} /></div>
              <div className="th">Photo Status<HelpText className="th-helptext" page={'device'} section={'photo_status'} /></div>
            </div>
            {devices.map((device) => (
               <Link to={`/configuration/devices/${device.id}`} key={device.id} className="tr">
                <div className="td bold">{device.name}</div>
                <div className="td">{device.last_updated}</div>
                <div className="td">{device.last_contacted}</div>
                <div className="td center"style={{ backgroundColor: onlineDeviceColor(device)}}>{device.online_device_count}</div>
                <div className="td center">{renderPhotoStatus(device.photo_status)}</div>
              </Link>
            ))}
          </div>
        </div>
      );
    }
  }

  state = {
    devices: [],
    loaded: false,
    error: null
  };

  componentDidMount() {
    let id = this.props.id;

    request("GET", `/v1/a/locations/${id}/devices`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ devices: data, loaded: true }))
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default Devices;
